import AdminUserDetailsForm from './AdminUserDetailsForm'

export default AdminUserDetailsForm
